import { AxiosInstance } from "axios"
import { CreateUpdateLocation, Location, LocationDetails, Shop } from "./locationsTypes"

export enum CompanyAdminLocationsQuery {
    LIST = "locations-for-company",
    DETAILS = "location-details-for-company",
    SHOPS = "shops-for-company",
}

type LocationsForCompanyParams = Readonly<{
    companyId: number
}>

export type LocationsForCompanyResponse = Readonly<{
    locations: Location[]
}>

export async function fetchLocationsForCompany(
    params: LocationsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<LocationsForCompanyResponse> {
    const url = `/companies/${params.companyId}/locations`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

type LocationForCompanyParams = Readonly<{
    locationId: string
}>

export type LocationForCompanyResponse = Readonly<{
    location: LocationDetails
}>

export async function fetchLocationForCompany(
    params: LocationForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<LocationForCompanyResponse> {
    const url = `/locations/${params.locationId}`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}

type ServiceResponse = Readonly<{
    serviceResponse: {
        displayMessage: string
    }
}>

export async function createLocationForCompany(
    { location, companyId }: { location: CreateUpdateLocation; companyId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const { data } = await axios.post(
        `/locations`,
        {
            location: {
                ...location,
                company: {
                    id: companyId,
                },
            },
        },
        {
            signal,
        },
    )
    return data
}

export async function updateLocationForCompany(
    { location, locationId }: { location: CreateUpdateLocation; locationId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const { data } = await axios.post(
        `/locations/${locationId}`,
        {
            location,
        },
        {
            signal,
        },
    )
    return data
}

type DeleteLocationForCompanyParams = Readonly<{
    locationId: number
}>

export async function deleteLocationForCompany(
    { locationId }: DeleteLocationForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse> {
    const { data } = await axios.delete(`/locations/${locationId}`, {
        signal,
    })
    return data
}

export type ShopsForCompanyResponse = Readonly<{
    shops: Shop[]
}>

export async function fetchShopsForCompany(
    params: LocationsForCompanyParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ShopsForCompanyResponse> {
    const url = `/companies/${params.companyId}/shops`

    const { data } = await axios.get(url, {
        params: {},
        signal,
    })

    return data
}
